export default __webpack_public_path__ + "static/media/TUR.eb344dd2.svg";